(() => {
  const selector = '.ht-tms--float .ht-tms__duo-selector';

  function setupSelector() {
    if (!document.body?.classList.contains('template-product')) return;

    const tmsSelector = document.querySelector(selector);
    const wrapper = tmsSelector?.closest('.ht-tms--float');

    if (!wrapper || wrapper.dataset.kontentaTmsReady === 'true') return;

    wrapper.dataset.kontentaTmsReady = 'true';

    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'kontenta-tms-close';
    closeButton.setAttribute('aria-label', 'Fechar seletor de idioma e moeda');
    closeButton.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" focusable="false">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
      </svg>
    `;

    closeButton.addEventListener('click', () => {
      wrapper.classList.add('kontenta-tms-hidden');
    });

    wrapper.appendChild(closeButton);
  }

  setupSelector();

  document.addEventListener('DOMContentLoaded', setupSelector);

  const observer = new MutationObserver(setupSelector);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
